export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/profiledropdown.9bf23261.svg","height":8,"width":12,"blurWidth":0,"blurHeight":0};